import { atom } from "jotai";

export interface IStockIncident {
    id?: number;
    inventory_item_id: number;
    trackable_item_id: string;
    defective_stock_qty?: number;
    defective_unit_qty?: number;
    reason?: string | null;
    severity?: string | null;
    notes?: string | null;
    reported_by?: number | null;
    created_at?: string;
    updated_at?: string;
}

export interface IStockIncidentInput extends Omit<IStockIncident, 'id' | 'created_at' | 'updated_at'> {}

export const stockIncidentsAtom = atom<IStockIncident[]>([]);
export const stockIncidentsLoadingAtom = atom<boolean>(false);

